/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

import { BarChart3 } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';

export function DashboardSettings() {
  const { dashboardSettings, updateDashboardSettings } = useApp();

  const handleDashboardSettingChange = (field: 'activityDays' | 'velocityWeeks', value: number) => {
    updateDashboardSettings({
      ...dashboardSettings,
      [field]: value
    });
  };

  return (
    <div style={{ 
      marginBottom: '32px',
      padding: '20px',
      background: '#f9f9f9',
      borderRadius: '8px',
      border: '1px solid #ddd'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
        <BarChart3 size={20} style={{ marginRight: '8px', color: '#0066cc' }} />
        <h3 style={{ margin: 0 }}>Dashboard Settings</h3>
      </div>

      <div className="form-group">
        <label htmlFor="activity-days">Activity Timeframe</label>
        <select
          id="activity-days"
          value={dashboardSettings.activityDays}
          onChange={(e) => handleDashboardSettingChange('activityDays', parseInt(e.target.value))}
          style={{
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            fontSize: '14px'
          }}
        >
          <option value={7}>Last 7 days</option>
          <option value={14}>Last 14 days</option>
          <option value={30}>Last 30 days</option>
        </select>
        <small style={{ color: '#666', fontSize: '12px', display: 'block', marginTop: '8px' }}>
          How many days of recent activity to display on the dashboard
        </small>
      </div>

      <div className="form-group">
        <label htmlFor="velocity-weeks">Velocity Graph Period</label>
        <select
          id="velocity-weeks"
          value={dashboardSettings.velocityWeeks}
          onChange={(e) => handleDashboardSettingChange('velocityWeeks', parseInt(e.target.value))}
          style={{
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            fontSize: '14px'
          }}
        >
          <option value={4}>Last 4 weeks</option>
          <option value={8}>Last 8 weeks</option>
          <option value={12}>Last 12 weeks</option>
        </select>
        <small style={{ color: '#666', fontSize: '12px', display: 'block', marginTop: '8px' }}>
          Number of weeks to display in the velocity graph
        </small>
      </div>

      <div style={{ 
        marginTop: '16px',
        padding: '12px',
        background: '#e9ecef',
        borderRadius: '4px',
        fontSize: '13px',
        color: '#495057'
      }}>
        <strong>Current Settings:</strong> Showing {dashboardSettings.activityDays} days of activity and {dashboardSettings.velocityWeeks} weeks of velocity
      </div>
    </div>
  );
}
